module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-details col-md-12 col-xs-12 ls-display-flex flex-wrap ls-md-margin-top row-reverse ls-no-padding"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12 col-sm-6 ls-no-padding-left ls-no-padding-right mobile-margin-top ls-md-padding-top ls-md-margin-bottom"
  }, [_c('invoice-details', {
    attrs: {
      "invoice": _vm.invoice
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-6 col-xs-12 ls-no-padding ls-sm-margin-bottom"
  }, [_c('div', {
    staticClass: "ls-box full-height ls-no-padding margin-right"
  }, [_c('h5', {
    staticClass: "subtitle ls-sm-margin-top"
  }, [_vm._v(_vm._s(_vm.$t('payments.methods.select_method')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-display-flex justify-content-center flex-wrap"
  }, [(_vm.useBilletMethod) ? _c('div', {
    staticClass: "col-md-3 col-sm col-xs-12",
    class: _vm.boxPaymentSize + ' payment-method-box margin-bottom',
    on: {
      "click": _vm.loadBillet
    }
  }, [_c('div', {
    staticClass: "ls-txt-center"
  }, [_c('h5', {
    staticClass: "ls-display-block ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('payments.methods.billet')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-4x fa-barcode",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.useCardMethod) ? _c('div', {
    staticClass: "col-md-3 col-xs-12",
    class: _vm.boxPaymentSize + ' payment-method-box margin-bottom',
    on: {
      "click": _vm.loadCard
    }
  }, [_c('div', {
    staticClass: "ls-txt-center"
  }, [_c('h5', {
    staticClass: "ls-display-block ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('payments.methods.card')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-4x fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.useTransferMethod) ? _c('div', {
    staticClass: "col-md-3 col-xs-12",
    class: _vm.boxPaymentSize + ' payment-method-box margin-bottom',
    on: {
      "click": _vm.loadTransfer
    }
  }, [_c('div', {
    staticClass: "ls-txt-center"
  }, [_c('h5', {
    staticClass: "ls-display-block ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('payments.methods.transfer')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-4x fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.useBalanceMethod) ? _c('div', {
    staticClass: "col-md-3 col-xs-12",
    class: _vm.boxPaymentSize + ' payment-method-box margin-bottom',
    on: {
      "click": _vm.loadLoginYapay
    }
  }, [_c('div', {
    staticClass: "ls-txt-center"
  }, [_c('h5', {
    staticClass: "ls-display-block ls-xs-margin-bottom ls-no-padding"
  }, [_vm._v(_vm._s(_vm.$t('payments.methods.yapay_balance')))]), _vm._v(" "), _c('img', {
    staticClass: "ls-sm-margin-top icon small-icon",
    attrs: {
      "src": require('../../../assets/img/logo-vindi-grey.png')
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.useNoPaymentSettings) ? _c('div', {
    staticClass: "ls-txt-center"
  }, [_c('span', [_vm._v("Não existe forma de pagamento disponível para essa fatura.")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Entre em contato com o vendedor.")])]) : _vm._e()]), _vm._v(" "), (_vm.customer) ? _c('div', {
    staticClass: "col-md-12 ls-sm-margin-bottom"
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Informações do cliente:")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.customer.name)), _c('br'), _vm._v("\n        " + _vm._s(_vm.customer.trade_name)), _c('br'), _vm._v("\n        " + _vm._s(_vm.customer.email) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc517082"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/payments/ChoosePayment.vue
// module id = 843
// module chunks = 1